import React, { useMemo } from 'react';
import { Carousel } from '@one-thd/sui-carousel';
import classNames from 'classnames';
import QuotesDetailsBox from './QuotesDetailsBox';
import fallbackViewTexts from '../../constants/fallbackViewTexts';
import { quotesPropType } from '../../utils/propTypes';
import NullViewContent from './QuotesNullView/NullViewContent';

const QuotesCarousel = ({ quotes }) => {
  const { imageAlt, imageUrl } = fallbackViewTexts;

  // Default: render quotes in carousel for all other cases
  const quotesCards = useMemo(() => {
    if (quotes === undefined || quotes?.length === undefined) {
      return [];
    }

    const cards = quotes?.map((quote, index) => (
      <QuotesDetailsBox
        key={`${quote.cartId}-${index}`}
        quote={quote}
        lastSlide={index === quotes.length - 1}
        index={index}
      />
    ));

    if (quotes.length <= 2) {
      cards.push(
        <div
          key="fallbackContent"
          className={
            classNames('sui-hidden', {
              '@6xl:sui-block': quotes.length === 2,
              '@2xl:sui-block': quotes.length === 1
            })
          }
        >
          <NullViewContent carousel />
        </div>
      );

      cards.push(
        <div
          key="fallbackImage"
          className={
            classNames('sui-hidden', {
              'sui-h-full sui-ml-4 @6xl:sui-block': quotes.length === 1
            })
          }
        >
          <img
            className="sui-h-52 sui-w-full"
            src={imageUrl}
            alt={imageAlt}
            width="1415"
            height="636"
          />
        </div>
      );
    }

    return cards;
  }, [quotes]);

  return (
    <div
      className={
        classNames(
          'sui-h-full [&_#sui-carousel-resets]:sui-h-full',
          '[&_.swiper]:sui-h-full [&_.swiper-wrapper]:sui-h-full')
      }
    >
      <Carousel
        type="peek"
        layout="full-bleed"
        containerId="quotes-carousel"
        slidesPerView="auto"
        slidesPerGroup={1}
        spaceBetween={0}
        breakpoints={{
          sm: { slidesPerGroup: 1, slidesPerView: 'auto' },
          md: { slidesPerGroup: 1, slidesPerView: 'auto' },
          lg: { slidesPerGroup: 1, slidesPerView: 'auto' },
          xl: { slidesPerGroup: 1, slidesPerView: 'auto' },
          '2xl': { slidesPerGroup: 1, slidesPerView: 'auto' },
        }}
        disableMargin
      >
        {quotesCards}
      </Carousel>
    </div>
  );
};
QuotesCarousel.propTypes = {
  quotes: quotesPropType.isRequired
};

QuotesCarousel.defaultProps = {
};

export default QuotesCarousel;
